import { graphql, loadQuery } from 'react-relay';
import { RelayEnvironment } from '../relay-env';
import type { ZnglyContext_App_Query } from './__generated__/ZnglyContext_App_Query.graphql';
import type { ZnglyContext_TopBarNavigation_Query } from './__generated__/ZnglyContext_TopBarNavigation_Query.graphql';
import type { ZnglyContext_User_Query } from './__generated__/ZnglyContext_User_Query.graphql';

export * from './__generated__/ZnglyContext_Styles_Fragment.graphql';
export const StylesFragment = graphql`
  fragment ZnglyContext_Styles_Fragment on ZnglyInfo {
    znglyInfo {
      headerPrimaryAccentClr
      headerPrimaryTxtClr
      headerBgClr
      backendPrimaryColor
      backendSecondaryColor
      footerSecondaryTxtClr
      footerPrimaryTxtClr
      footerBgClr
      footerAccentClr
      fontStyle
      bodyDescBoxTxtClr
      bodyDescBoxClr
      headerSecondaryAccentClr
      headerSecondaryTxtClr
      pagePrimaryAccClr
      pagePrimaryTxtClr
      pageSecondaryAccClr
      pageSecondaryTxtClr
      userMenuBackgroundClr
      userMenuLinkClr
      userMenuLinkHoverClr
      catZnglistClr
      ddBgClr
      ddPrimaryTxtClr
      ddSecondaryTxtClr
      readMorePrimaryClr
      readMoreSecondaryClr
      readMorePrimaryTxtClr
      ctaPrimaryClr
      ctaSecondaryClr
      ctaPrimaryTxtClr
      shareBtnPrimaryClr
      shareBtnSecondaryClr
    }
  }
`;

export * from './__generated__/ZnglyContext_App_Query.graphql';
export const AppQuery = graphql`
  query ZnglyContext_App_Query {
    # Settings
    siteSettings {
      canDoAiSearch
    }

    znglyInfo(id: "site-info", idType: SLUG) {
      ...Header_ZnglyInfo_Desktop
      ...Footer_SiteInfo
      ...analytics_Dash_Fragment
      ...ZnglyContext_Styles_Fragment
      znglyInfo {
        dashboardLink
        browserTabTitle
        searchPlaceholder
        privacyUserConsentLevel
        searchPlaceholderAi
        searchImage {
          ...Media_Url_Fragment @relay(mask: false)
        }
        searchImageAi {
          ...Media_Url_Fragment @relay(mask: false)
        }
        qrPrimaryColor
        qrSecondaryColor
        qrImage {
          ...Media_Url_Fragment @relay(mask: false)
        }
      }
    }
  }
`;

export const appQueryRef = loadQuery<ZnglyContext_App_Query>(RelayEnvironment, AppQuery, {});

export * from './__generated__/ZnglyContext_User_Query.graphql';
export const UserQuery = graphql`
  query ZnglyContext_User_Query {
    # Current User
    viewer {
      ...User_Fragment
    }
  }
`;
export const userQueryRef = loadQuery<ZnglyContext_User_Query>(RelayEnvironment, UserQuery, {});

export * from './__generated__/ZnglyContext_TopBarNavigation_Query.graphql';
export const TopBarNavigationQuery = graphql`
  query ZnglyContext_TopBarNavigation_Query {
    # Categories
    ...Category_Fragment

    # hubs
    hubs(first: 1000, where: { status: PUBLISH, order: ASC, orderBy: [PostOrder] }) {
      edges {
        node {
          slug
          title
          template
          postOrder
        }
      }
    }

    # znglists
    znglists(first: 1000, where: { status: PUBLISH }) {
      edges {
        node {
          slug
          title
          znglist {
            order
          }
        }
      }
    }
  }
`;
export const topBarNavigationQueryRef = loadQuery<ZnglyContext_TopBarNavigation_Query>(
  RelayEnvironment,
  TopBarNavigationQuery,
  {}
);

export * from './__generated__/ZnglyContext_Backend_Query.graphql';

export const BackendQuery = graphql`
  query ZnglyContext_Backend_Query {
    # Users
    ...Users_Fragment
    # Settings
    ...ZnglyInfo_Settings_Fragment
    # Site Settings
    ...SiteSettings_Fragment
    # Zngly Content
    ...ZnglyVideos_Pagination_Fragment
      @arguments(
        first: 24
        after: null
        where: {
          search: null
          orderby: null
          mediaName: null
          stati: [PENDING, PUBLISH, HIDDEN, HIDDEN_B_S, DRAFT]
          authorIn: null
          dateQuery: null
        }
      )
  }
`;
